import ListView from "../../../../common/models/listViews/listView";
import SingleSelectedProperty from "../../../../common/state/modules/singleSelectedProperty";
import GloballySelected from "../../../../common/state/modules/globallySelected";
import ListViewContentElement from "../../../../common/models/listViews/elements/listViewContentElement";
import ListViewFilterElement from "../../../../common/models/listViews/elements/listViewFilterElement";
import ListViewMainAction from "~/models/listViews/elements/listViewMainAction";

export default class Selected extends GloballySelected {
  static listView = new SingleSelectedProperty('listView', () => ListView);
  static listViewContentElement = new SingleSelectedProperty('listViewContentElement', () => ListViewContentElement);
  static listViewFilterElement = new SingleSelectedProperty('listViewFilterElement', () => ListViewFilterElement);
  static listViewMainAction = new SingleSelectedProperty('listViewMainAction', () => ListViewMainAction);
}